import React, { Component } from 'react';
import QR from 'qrcode.react';
import { Container } from './style';
import {uploadFileToPicJd} from '../../../services/uploadService';
import html2Image from './html2Image';
import Toast from '../../common/toast';
import { DEFAULT_ERROR_MSG } from '../../../utils/config'
import { jdAppShare,getUrlParms,toLoginPage} from '../../../utils/tool'

import logo from './img/logo.jpeg'

const publishSourceByUrl = getUrlParms("publishSource") || ""
const announcementByUrl = getUrlParms("announcement") || ""
const agencyByUrl = getUrlParms("agency") || ""
const orgIdType = getUrlParms("orgIdType") || ""

const rootFontSize = parseInt(document.querySelector('html').style.fontSize);
class SharePoster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      curProducts: [],
      shareImageUrl: null
    }
    this.ref = React.createRef()
  }

  // 分享海报，给父组件调用
  sharePosterImage() {
    const {
      onComplete
    } = this.props
    const {
      shareImageUrl
    } = this.state
    if (!shareImageUrl) {
      html2Image({
        dom: this.ref.current,
        backgroundColor: null,
        callback: (img) => {
          if (img && img.getAttribute('src') && img.getAttribute('src').length) {
            const base64Str = img.getAttribute('src').split(';base64,')[1]
            this.uploadImg(base64Str);
          } else {
            onComplete && onComplete();
            Toast.show({
              message: '生成海报失败',
              duration: 1500
            })
          }
        }
      })
    } else {
      this.callupSharePosterPanel(shareImageUrl);
      onComplete && onComplete();
    }
  }

  // 上传海报图片
  uploadImg(base64Str) {
    const {
      onComplete
    } = this.props
    uploadFileToPicJd(base64Str).then(imgUrl => {
      if (imgUrl && imgUrl.length) {
        const shareImageUrl = `https://img13.360buyimg.com/paimai/${imgUrl}`
        this.setState({
          shareImageUrl
        })
        onComplete && onComplete();
        this.callupSharePosterPanel(shareImageUrl);
      } else {
        onComplete && onComplete();
        Toast.show({
          message: DEFAULT_ERROR_MSG,
          duration: 1500
        })
      }
    }).catch(err => {
      console.log(err)
      onComplete && onComplete();
      if (err && err.msg === '201') {
        Toast.show({
          message: '您未登录，请先登录再分享',
          duration: 1500
        })
        setTimeout(() => {
          toLoginPage()
        }, 1500)
        return
      } else {
        Toast.show({
          message: DEFAULT_ERROR_MSG,
          duration: 1500
        })
      }
    })
  }

  // 根据拍品数量获取对应的class（1：1行1个 2: 1行2个 3: 1行3个 4: 1行2个 5: 只展示4个，1行2个， >=6:展示6个，1行3个）
  getProductClass() {
    const {
      curProducts
    } = this.state;

    const len = curProducts.length;
    if (len <= 3) {
      return `product${len}`
    } else if (len === 4) {
      return `product2`
    } else if (len === 6) {
      return 'product3'
    }
    return ''
  }

  // 唤起分享海报面板
  callupSharePosterPanel(shareImg) {
    jdAppShare({
      channel: ['QRCode'],
      shareImg,
      senDirectShare: true
    })
  }

  componentWillReceiveProps(nextProps) {
    // console.log('products', nextProps.products)
    if (nextProps.products && nextProps.products.length) {
      // 最多展示4个
      let curProducts = nextProps.products
      if (nextProps.products.length >= 4) {
        curProducts = nextProps.products.slice(0, 4)
      }else if(nextProps.products.length == 3){
        curProducts = nextProps.products.slice(0, 2)
      }
      this.setState({
        curProducts
      })
    }
  }

  render() {
    const {
      vendorId,
      shopName,
      logoUrl,
      orgTypeName,
      isDefaultLogo,
      shopNewestCategory,
      businessTxt,
    } = this.props
    const {
      curProducts
    } = this.state
    return (
      <div style={{ height: 0,opacity: 0 }}>
        <Container ref={this.ref}>
          <div className="vendor">
            <div className="vendor-wrap">
              <div className={`vendor-logowrap ${isDefaultLogo ? 'vendor-logowrap--default' : ''}`}>
                <img className="vendor-logo" src={logoUrl} />
              </div>
              <p className="vendor-name">{shopName}</p>
              {
                businessTxt ? (
                  <div className="vendor-orgs">
                    <span className="vendor-org">{businessTxt}</span>
                  </div>
                ) : ''
              }
              {shopNewestCategory && 
              <div className="vendor-categorys">
                <span>最新拍品类目：{shopNewestCategory.join("、")}</span>
              </div>
              }
            </div>
          </div>
          {
            curProducts && curProducts.length ? (
              <div className={`products ${curProducts.length === 1 ? 'products1' : ''}`}>
                {
                  curProducts.map((product, index) => {
                    return (
                      <div key={index} className={`product ${this.getProductClass()}`}>
                        {
                          product.productImage && product.productImage.indexOf("jfs")>-1 ? <img className="product-img" src={`//img1${index % 5}.360buyimg.com/paimai/s210x140_${product.productImage}!cc_3x2!50`} /> :
                          <img className="product-img" src={product.completeProductImageUrl || `https://storage.jd.com/pharos-court/${product.productImage}`} />
                        }
                        
                      </div>
                    )
                  })
                }
              </div>
            ) : ''
          }
          <div className="more">
            <div className="more-left">
              <p className="more-text1">长按识别二维码</p>
              <p className="more-text2">查看更多竞价信息</p>
              <img className="more-img" src="//img12.360buyimg.com/imagetools/s195x50_jfs/t1/99428/13/42126/16604/65c2df24F148c88ee/9cd6c16be4e81941.png" />
            </div>
            <div className="more-right">
              <div className="more-qrcode">
                <QR 
                  value={`${window.location.origin}/#/mall/${vendorId}?agencyByUrl=${agencyByUrl}&announcementByUrl=${announcementByUrl}&publishSource=${publishSourceByUrl}&orgIdType=${orgIdType}`} 
                  size={rootFontSize * 1.77} 
                />
              </div>
            </div>
          </div>
        </Container>
      </div>
    );
  }
}

export default SharePoster;
